import React, { useState, useEffect, useMemo } from "react";
import {
  Grid,
  Button,
  Typography,
  Accordion, AccordionSummary, AccordionDetails, Tooltip
} from "@mui/material";
import PersonalInformation from "../components/personal-information";
import SavingsAndContributions from "../components/savings-and-contributions";
import Income from "../components/income";
import Goals from "../components/goals";
import Insurance from "../components/insurance";
import PlanAssumptions from "../components/plan-assumptions";
import SpendingGoals from '../components/spending-goals'
import Fia from "../components/fia";
import RothIra from "../components/roth-ira";
import SuccessDialog from '../components/success-dialog'
import UnsavedDataModal from "../components/unsaved-data-modal";
import {getCurrentYear, isAccountRothConversionIntoFIA} from "../shared/shared";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import {
  MAX_CURRENCY,
  MAX_CURRENCY_FUTURE_ADJUSMENTS,
  MAX_YEAR,
  PLAN_STATUS,
  SAGA_GET_PLANINPUT,
  SAGA_GET_PLAN_CASH_FLOW,
  USER_CONCIERGE,
  ACTION_SET_CURRENTCLIENT,
  ACTION_LOCK_FUTURE_DESTINATION,
  ACTION_SET_TRUST_LIST,
  FUNDING_SOURCE_EXCESS_INCOME,
  FUNDING_SOURCE_CURRENT_INCOME
} from "../shared/constants";
import {
  FILINGSTATUS_SINGLE,
  FILINGSTATUS_MARRIED,
} from "../shared/constants";
import { useCookies } from "react-cookie";
import ReactDOMServer from 'react-dom/server'
import {
  savePlanInputs,
  publishPlan,
  saveAdjustments,
  getClient,
  saveFuturePlanRoadmap,
  getAdjustments,
  generatePDF,
  getQuestionsPlanInput,
  getRILAHistoricReturns,
  saveFuturePlanWizardSettings
} from "../shared/api";
import ValidationMessageModal from "../components/validation-message-modal";
import PdfPlanInput from "../components/layout-pdf-plan-input";
import { SERVER_URL } from "../config";
import { useModal } from "../hooks/useModal";
import ModalWarningAdvisor from "../components/modal-warning-advisor";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {withStyles} from "@mui/styles";
import {ACTION_SET_CURRENTFP_ID, ROTH_DESTINATION_LEVEL_INCOME_FIA, ROTH_DESTINATION_INCREASING_PAYOUT_FIA} from "../shared/constants";
import PlanAutomationWizard from "../components/plan-automation-wizard";

export const StyledTooltip = withStyles({
  tooltip: {
    color: "white",
    backgroundColor: "#f31700",
    fontSize: "16px",
    padding: "5px",
    marginLeft: "5px",
    maxWidth: 'none',
  }
})(Tooltip);

const PlanInputs = (props) => {
  const currentUserName = useSelector((state) =>
    state.dataStore.getIn(["currentUser", "name"])
  );

  const dispatch = useDispatch();
  const location = useLocation();

  const { isOpen, openModal, closeModal, message, setMessage } = useModal();
  const warningModal = useModal();

  const [validation, setValidation] = useState({
    client: {
      age: { valid: true, message: "", show: false },
      firstName: { valid: true, message: "", show: false },
      lastName: { valid: true, message: "", show: false },
      retirementAge: { valid: true, message: "", show: false },
    },
    spouse: {
      age: { valid: true, message: "", show: false },

      firstName: { valid: true, message: "", show: false },

      lastName: { valid: true, message: "", show: false },

      retirementAge: { valid: true, message: "", show: false },

    },
    accounts: [{
      accountValue: { valid: true, message: "", show: false },
      costBasis: { valid: true, message: "", show: false },
      detailsAccountMust_100: { valid: true, message: "", show: false },
      contributions: {
        amount: { valid: true, message: "", show: false },
        startYear: { valid: true, message: "", show: false },
        endYear: { valid: true, message: "", show: false },
      }
    }],
    goals: [{
      amount: { valid: true, message: "", show: false },
      startYear: { valid: true, message: "", show: false },
      endYear: { valid: true, message: "", show: false },
    }
    ],
    incomes: [
      {
        amount: { valid: true, message: "", show: false },
        startYear: { valid: true, message: "", show: false },
        endYear: { valid: true, message: "", show: false },
      }
    ],
  });

  const [futurePlanValidation, setFuturePlanValidation] = useState({
    fiaTransfers: [{
      transferAmount:
      {
        valid: true,
        message: "transfer amount",
        show: false
      },
      transferEndYear:
      {
        valid: true,
        message: "transfer end year",
        show: false
      },
      accountToTransfer: {
        valid: true,
        message: "account transfer",
        show: false
      }
    }],
    insuranceTransfers: [{
      transferAmount:
      {
        valid: true,
        message: "",
        show: false
      },
      transferEndYear:
      {
        valid: true,
        message: "",
        show: false
      },
      accountToTransfer: {
        valid: true,
        message: "",
        show: false
      },
      deathBenefit: {
        valid: true,
        message: "",
        show: false
      },
      insuranceDetails: [],
      insuranceDetailsValid: [],
      fileName: null
    }],
    rothTransfers: [
      {
        transferAmount:
        {
          valid: true,
          message: "",
          show: false
        },
        detailsRothConversionMust_100: {
          valid: true,
          message: "",
          show: false
        },
        numberOfYears: {
          valid: true,
          message: "",
          show: false
        },
      }
    ],
    spendingGoals: [
      {
        transferAmount: {
          valid: true,
          message: "",
          show: false
        }
      }
    ]
  });

  const [questionsPlan, setQuestionsPlan] = useState({})

  const [state, setState] = useState({
    client: {
      age: 60,
      firstName: "",
      id: null,
      isMarried: false, // filing status?
      isRetired: false,
      hasSpouse: false,
      lastName: "",
      retirementAge: { year: 67, value: 67 },
      filingStatus: {
        id: FILINGSTATUS_SINGLE,
        value: "Single",
      }
    },
    spouse: {
      age: 60,
      firstName: "",
      id: null,
      isMarried: true,
      isRetired: true,
      lastName: "",
      retirementAge: { year: 67, value: 67 },
    },
    clientQuestionView: [
      {
        answer: "",
        clientQuestionId: null,
        questionId: 1,
        editIndex: 0
      },

    ],
    accounts: [],
    incomes: [],
    goals: [],
    insurancePolicies: [],
    assumptions: {
      cola: 0.02,
      ssCola: 0.02,
      pensionCola: 0.0,
      stateTax: 0.05,
      capitalGainsTax: 0.15,
      ficaTax: 0,
    },
    fiaTransfers: [],
    insuranceTransfers: [],
    rothTransfers: [],
    spendingGoals: [],
    isCalculated: false,
    planStatus: PLAN_STATUS.incomplete,
    openModalPlanValidation: false,
    openModalSuccess: false,
    openModalFutureValidation: false,
    showFutureAdjustments: false,
    isAccountModified: false,
    deletedAccounts: [],
    deletedAccountTransfer: [],
    needSaveAdjustmentFirst: false,
  });

  const [showUnsavedChangesModal, updateShowUnsavedChangesModal] = useState(false);
  const [unsavedNavTarget, updateUnsavedNavTarget] = useState(null);
  const [showPlanAutomationModal, updateShowPlanAutomationModal] = useState(false);

  const [sAndPHistoricalReturn, updateSAndPHistoricalReturn] = useState({"averageReturn":0,"standardDeviation":0});

  const [isCalculating, setIsCalculating] = useState(false);
  const [calculateBtnLabel, setCalculateBtnLabel] = useState(null);

  const authorization = useSelector((state) =>
    state.dataStore.getIn(["currentUser", "authorization"])
  );

  const [cookies, setCookie] = useCookies(["loginToken"]);
  const token = useSelector((state) => state.dataStore.getIn(["loginInfo", "authorizationToken"]));

  const currentFinancialProfessional = useSelector(state =>
    state.dataStore.getIn(['financialProfessional'])
  ).toJS();

  const authToken = useMemo(() => {
    if (token != null) {
      return token;
    }
    return cookies["loginToken"];
  }, []);

  const { clientFpid, clientId } = props;
  const { fpid = clientFpid, id = clientId } = useParams();

  useEffect(() => {
    dispatch({
      type: ACTION_SET_CURRENTFP_ID,
      value: fpid
    });
    generateCalculateLabel();
  }, [fpid]);

  useEffect(() => {
    getRILAHistoricReturns(authToken).then(response => {
      updateSAndPHistoricalReturn(response);
    });
    generateCalculateLabel();
  }, [id]);

  useEffect(() => {
    updatePlan();
    generateCalculateLabel();
  }, [sAndPHistoricalReturn]);

  const updatePlan = async (planStatus) => {

    let cId = null;
    if (id !== "null") {
      cId = id;
    } else {
      cId = state.client.id;
    }

    if (cId !== null) {
      const responseActualPlan = await getClient(cId, authToken);
      const responseFuturePlan = await getAdjustments(cId, authToken);
      await updateSavedPlan(
        responseActualPlan, responseFuturePlan, planStatus
      );
      return;
    }

    dispatch({
      type: ACTION_SET_TRUST_LIST,
      value: []
    });
  }

  useEffect(() => {
    if (state.isCalculated) {
      setState((v) => ({ ...v, isCalculated: false }))
    }
    validate();
    generateCalculateLabel();
  }, [state.client, state.spouse, state.isAccountModified, state.accounts, state.incomes, state.goals, state.clientQuestionView, state.assumptions]);

  useEffect(() => {
    props.setGoals((v) => ({ ...v, goals: state.goals }));
    generateCalculateLabel();
  }, [state.goals]);

  useEffect(() => {
    validateFuturePlan();
    generateCalculateLabel();
  }, [state.fiaTransfers, state.insuranceTransfers, state.rothTransfers, state.accounts, state.spendingGoals]);

  useEffect(() => {
    validate();
    generateCalculateLabel();
  }, [state.fiaTransfers])


  const validateAdvisorId = () => {
    if (location.pathname.includes('plan-output')) return true;
    if (currentFinancialProfessional.advisorId == fpid) return true;
    warningModal.openModal();
    return false;
  }

  useEffect(() => {
    validateAdvisorId();

    getQuestionsPlanInput(authToken).then((questions) => {
      const groupQuestions = questions.data.reduce((hash, obj) => ({ ...hash, [obj['questionType'].toLowerCase().replace(/\s/g, '')]: (hash[obj['questionType'].toLowerCase().replace(/\s/g, '')] || []).concat(obj) }), {})
      setQuestionsPlan(groupQuestions)
    });

    generateCalculateLabel();
  }, []);

  const callbackIsPageUpdated = (val) => {
    if (props.isPageUpdated) props.isPageUpdated(val);
  };

  const update = (objectName) => (field) => (event) => {
    // registerOnLoadHandler();

    if (objectName === "client" && field === "hasSpouse" && !event.value) {
      setState({
        ...state,
        planStatus: PLAN_STATUS.changed,
        [objectName]: field === null ? null : {
          ...state[objectName],
          [field]: event.value,
        },
        accounts: state.accounts.map(item => {
          return {
            ...item,
            owner: "CLIENT",
          }
        }),
        incomes: state.incomes.map(item => {
          return {
            ...item,
            owner: "CLIENT",
          }
        }),
        fiaTransfers: state.fiaTransfers.map(item => {
          return {
            ...item,
            owner: "CLIENT",
          }
        }),
        insuranceTransfers: state.insuranceTransfers.map(item => {
          return {
            ...item,
            owner: "CLIENT",
          }
        }),
        rothTransfers: state.rothTransfers.map(item => {
          return {
            ...item,
            owner: "CLIENT",
          }
        }),
      });
      callbackIsPageUpdated(true);
    } else {
      setState({
        ...state,
        planStatus: PLAN_STATUS.changed,
        [objectName]: field === null ? null : {
          ...state[objectName],
          [field]: event.value,
        },
      });
      callbackIsPageUpdated(true);
    }
  };

  const updateItemInCollection = (collection) => (dataItem) => {
    setState({
      ...state,
      planStatus: PLAN_STATUS.changed,
      [collection]: state[collection].map((item) => {
        if (item.editIndex !== dataItem.editIndex) return item;
        return {
          ...dataItem
        }
      })
    });

    callbackIsPageUpdated(true);
  }

  const updateCollection = (collection) => (field) => (dataItem, value) => {
    // registerOnLoadHandler();

    setState({
      ...state,
      planStatus: field === "isExpanded" ? state.planStatus : PLAN_STATUS.changed,
      [collection]: state[collection].map((item) => {
        if (item.editIndex !== dataItem.editIndex) return item;
        if (field === "insuranceDetails") {
          return {
            ...item,
            [field]: value,
            "fileName": dataItem.fileName,
            "insuranceDetailsValid": dataItem.valid,
          }
        }

        if (field === "accountType" && item.accountId < 0) {
          return {
            ...item,
            [field]: value,
            accountId: null
          }
        }

        if (field === "transferStartYear" && dataItem.annuityType === "GUARANTEED_INCOME") {
          return {
            ...item,
            [field]: value,
            "transferEndYear": value
          }
        }

        if (field === "stackingMultiplier" || field === "increasingGrowthMultiplier") {
          if (value > 500) {
            value = 500;
          } else if (value < 0) {
            value = 0;
          }
          return {
            ...item,
            [field]: value,
          }
        }

        const updatedItem = {
          ...item,
          [field]: value
        };

        if (collection === "incomes") {
          updatedItem["showJointTrustOptions"] = (updatedItem["incomeType"] === "OTHER");
        }
        if (collection === "fiaTransfers" && (field === "taxType" || field === "accountId")) {
          updatedItem["conversionType"] = isAccountRothConversionIntoFIA(updatedItem, state.accounts) ? "ALL" : null;
        }

        return updatedItem;
      }),
    });
    if (field !== "isExpanded" || state.planStatus === PLAN_STATUS.changed) callbackIsPageUpdated(true);
  };

  const handleIsAccountsModified = (field) => (dataItem, value) => {
    // registerOnLoadHandler();

    const updateOwnerField = () => {
      const accounts = state.accounts.map((item) => {
        if (item.editIndex !== dataItem.editIndex) return item;
        return {
          ...item,
          [field]: value,
        };
      });

      const fiaTransfers = state.fiaTransfers.map(item => {
        return {
          ...item,
          accountId: getDefaultAccountId(accounts, "owner", item.accountId, item.owner)
        }
      });
      const insuranceTransfers = state.insuranceTransfers.map(item => {
        return {
          ...item,
          accountId: getDefaultAccountId(accounts, "owner", item.accountId, item.owner)
        }
      });
      const rothTransfers = state.rothTransfers.map(item => {
        return {
          ...item,
          accountId: getDefaultAccountId(accounts, "owner", item.accountId, item.owner, ["PRE-TAX"])
        }
      });

      setState({
        ...state,
        planStatus: field === "isExpanded" ? state.planStatus : PLAN_STATUS.changed,
        accounts: accounts,
        fiaTransfers: fiaTransfers,
        insuranceTransfers: insuranceTransfers,
        rothTransfers: rothTransfers,
        isAccountModified: field === "isExpanded" ? false : !state.isAccountModified,
      });
      if (field !== "isExpanded" || state.planStatus === PLAN_STATUS.changed) callbackIsPageUpdated(true);
    }

    if (field === "owner") {
      updateOwnerField();
      return;
    }

      setState({
        ...state,
        planStatus: field === "isExpanded" ? state.planStatus : PLAN_STATUS.changed,
        accounts: state.accounts.map((item) => {
          if (item.editIndex !== dataItem.editIndex) return item;

          if (field === "taxType") {
            return {
              ...item,
              [field]: value,
              showJointTrustOptions: value === "NON-QUALIFIED"
            }
          }

          return {
            ...item,
            [field]: value,
          };
        }),
        isAccountModified: field === "isExpanded" ? false : !state.isAccountModified,
      });
      if (field !== "isExpanded" || state.planStatus === PLAN_STATUS.changed) callbackIsPageUpdated(true);
  };

  const updateQuestions = (collection) => (field) => {

    let shallowAnswers = state[collection];
    const findQuestionID = shallowAnswers.findIndex(v => v.questionId === field.questionId)

    if (findQuestionID === -1) {
      addToCollection(collection)(field)
    } else {
      setState((existingItems) => ({
        ...existingItems, [collection]: [
          ...existingItems[collection].slice(0, findQuestionID),
          field,
          ...existingItems[collection].slice(findQuestionID + 1),
        ],
        planStatus: PLAN_STATUS.changed
      }));
      callbackIsPageUpdated(true);
    }
  }

  const addToCollection = (collection) => (item) => {
    // registerOnLoadHandler();

    const newEditIndex = Math.max(
      ...state[collection].map((item) => item.editIndex)
    );

    const newItem = {
      ...item,
      editIndex: state[collection].length > 0 ? newEditIndex + 1 : 0,
    };

    setState({
      ...state,
      planStatus: PLAN_STATUS.changed,
      [collection]: state[collection].concat([newItem]),
    });
    callbackIsPageUpdated(true);
  };

  const deleteFromCollection = (collection) => (dataItem) => {
    // registerOnLoadHandler();

    let deletedAccounts = state.deletedAccounts;
    let deletedAccountTransfer = state.deletedAccountTransfer;
    if (collection === "accounts") {
      if (!state.deletedAccounts.includes(dataItem.id)) deletedAccounts.push(dataItem.id);
    } else if (collection === "fiaTransfers" || collection === "insuranceTransfers" || collection === "rothTransfers") {
      if (!state.deletedAccountTransfer.includes(dataItem.accountId)) deletedAccountTransfer.push(dataItem.accountId);
    }

    if (collection === "accounts") {
      const accounts = state.accounts.filter(
          (item) => item.editIndex !== dataItem.editIndex
      );

      const fiaTransfers = state.fiaTransfers.map(item => {
        return {
          ...item,
          accountId: getDefaultAccountId(accounts, "owner", item.accountId, item.owner)
        }
      });
      const insuranceTransfers = state.insuranceTransfers.map(item => {
        return {
          ...item,
          accountId: getDefaultAccountId(accounts, "owner", item.accountId, item.owner)
        }
      });
      const rothTransfers = state.rothTransfers.map(item => {
        return {
          ...item,
          accountId: getDefaultAccountId(accounts, "owner", item.accountId, item.owner, ["PRE-TAX"])
        }
      });

      setState({
        ...state,
        planStatus: PLAN_STATUS.changed,
        accounts: accounts,
        fiaTransfers: fiaTransfers,
        insuranceTransfers: insuranceTransfers,
        rothTransfers: rothTransfers,
        deletedAccounts: deletedAccounts,
        deletedAccountTransfer: deletedAccountTransfer,
        needSaveAdjustmentFirst: deletedAccounts.length > 0 ? true : state.needSaveAdjustmentFirst,
      });
      callbackIsPageUpdated(true);
    } else {
      setState({
        ...state,
        planStatus: PLAN_STATUS.changed,
        [collection]: state[collection].filter(
            (item) => item.editIndex !== dataItem.editIndex
        ),
        deletedAccounts: deletedAccounts,
        deletedAccountTransfer: deletedAccountTransfer,
      });
      callbackIsPageUpdated(true);
    }
  };

  const updateAccountContribution = (account) => (field) => (event) => {
    // registerOnLoadHandler();

    setState({
      ...state,
      planStatus: PLAN_STATUS.changed,
      accounts: state.accounts.map((item) => {
        if (item.editIndex !== account.editIndex) return item;
        return {
          ...item,
          contributions: {
            ...item.contributions,
            [field]: event.value,
          },
        };
      }),
      isAccountModified: !state.isAccountModified
    });
    callbackIsPageUpdated(true);
  };

  const isObjectValid = (object) => {
    const keys = Object.keys(object);
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      if (k !== "contributions") {
        if (!object[k].valid) return false;
      } else if (!isObjectValid(object[k])) {
        return false;
      }
    }
    return true;
  };

  const currentYear = getCurrentYear();

  const validateStartYear = (item) => {
    return (
      item.startYear <= item.endYear &&
      item.startYear >= currentYear &&
      item.startYear <= MAX_YEAR
    );
  };

  const validateEndYear = (item) => {
    return (
      item.endYear >= item.startYear &&
      item.endYear >= currentYear &&
      item.endYear <= MAX_YEAR
    );
  };

  const validate = () => {
    const fiaGuaranteedIncomes = state.fiaTransfers
      .filter(item => {
        return item.annuityType === "GUARANTEED_INCOME"
      });

    const validateAccountContribution = (contributions) => {
      if (contributions.contributionSourceType === "OUTSIDE_SOURCE") return true;
      const startYear = contributions.startYear;
      const endYear = contributions.endYear;

      let isValid = false;
      if (state.incomes) {
        state.incomes.forEach(income => {
          if (income.startYear <= startYear && income.endYear >= endYear) {
            isValid = true;
          }
        });
      }
      return isValid;
    }

    const minFIAGIinvalid = fiaGuaranteedIncomes.filter(item => item.yearsOfDeferral + state.client?.age < 50).map(e => e.yearsOfDeferral);

    const fiaValidations = location.pathname.includes('plan-output') ? !fiaGuaranteedIncomes
      .map(guarantedIncome => (guarantedIncome.yearsOfDeferral + state.client?.age) >= 50)
      .includes(false)
      : true;

    setValidation((v) => {
      return {
        ...v,
        client: {
          age: {
            valid: state.client.age > 0,
            message: "Please review your age client to ensure it is valid.",
            show: false
          },
          firstName: {
            valid: state.client.firstName !== "",
            message: "Please review your first name client to ensure it is valid.",
            show: false
          },
          lastName: {
            valid: state.client.lastName !== "",
            message: "Please review your last name client to ensure it is valid.",
            show: false
          },
          retirementAge: {
            valid: true,
            message: "Please review your retirement age client to ensure it is valid.",
            show: false
          },
          fiaPayouts:
          {
            valid: fiaValidations,
            message: `FIA Payouts can only begin at age 50. The client is ${state.client.age} years old and the current FIA payout is set to ${Math.min(...minFIAGIinvalid)} years of deferral.  Please adjust the client age and recalculate to view the Future Adjustments.`,
            show: true,
          }
        },
        spouse: {
          age: {
            valid: !state.client.hasSpouse || state.spouse?.age > 0,
            message: "Please review your age spouse to ensure it is valid.",
            show: false
          },
          firstName: {
            valid: !state.client.hasSpouse || state.spouse?.firstName !== "",
            message: "Please review your first name spouse to ensure it is valid.",
            show: false
          },
          lastName: {
            valid: !state.client.hasSpouse || state.spouse?.lastName !== "",
            message: "Please review your last name spouse to ensure it is valid.",
            show: false
          },
          retirementAge: {
            valid: true,
            message: "Please review your retirement age spouse to ensure it is valid.",
            show: false
          },
        },
        accounts: state.accounts.length === 0 ? [{ needAtLeastOne: { valid: false, message: "Need at least one account", show: false } }] :
          state.accounts.map((item) => {
            return {
              accountValue: {
                valid: item.value >= 0.1 && item.value <= MAX_CURRENCY,
                message: "Please review your account value to ensure it is valid.",
                show: false
              },
              costBasis: {
                valid: item.costBasis >= (item.taxType === 'PRE-TAX' ? 0 : 1) && item.costBasis <= MAX_CURRENCY,
                message: "Please review your cost basis to ensure it is valid.",
                show: false
              },
              detailsAccountMust_100: {
                valid: (parseFloat(item.bonds) + parseFloat(item.cash) + parseFloat(item.stocks)) === 100,
                message: "Please ensure the account allocation adds up to 100%.",
                show: false
              },
              contributionValid: {
                valid: validateAccountContribution(item.contributions),
                message: "Please create an income to cover the current income contribution period.",
                show: false
              },
              contributions: {
                amount:
                {
                  valid: item.contributions.amount >= 0.0 && //before item.contributions.value returns undefined
                    item.contributions.amount <= MAX_CURRENCY, //item.contributions.value returns undefined
                  message: "Please review your amount in contributions to ensure it is valid.",
                  show: false
                },
                startYear: {
                  valid: validateStartYear(item.contributions),
                  message: "Please review your start year to ensure it is valid.",
                  show: false
                },
                endYear: {
                  valid: validateEndYear(item.contributions),
                  message: "Please review end year basis to ensure it is valid.",
                  show: false
                },
              },
            };
          }),
        incomes: state.incomes.map((item) => {
          const validationOwner = state.client.hasSpouse ? true
            : item.owner === "CO_CLIENT" ? false : true;

          return {
            amount: {
              valid: item.amount >= 0.1 && item.amount <= MAX_CURRENCY,
              message: "Please review amount incomes to ensure it is valid.",
              show: false
            },
            owner: {
              valid: validationOwner,
              message: "Please review the incomes owner",
              show: false
            },
            startYear: {
              valid: validateStartYear(item),
              message: "Please review start year to ensure it is valid.",
              show: false
            },
            endYear: {
              valid: validateEndYear(item),
              message: "Please review end year to ensure it is valid.",
              show: false
            },
          };
        }),
        goals: state.goals.length === 0 ? [{ needAtLeastOne: { valid: false, message: "Need at least one goal", show: false } }] :
          state.goals.map((item) => {
            return {
              amount: {
                valid: item.amount >= 0.1 && item.amount <= MAX_CURRENCY,
                message: "",
                show: false
              },
              startYear: {
                valid: validateStartYear(item),
                message: "Please review start year goals to ensure it is valid.",
                show: false
              },
              endYear: {
                valid: validateEndYear(item),
                message: "Please review end year goals to ensure it is valid.",
                show: false
              },
            };
          }),
      };
    });

    const isClientValid = () => {
      return isObjectValid(validation.client);
    };

    const isSpouseValid = () => {
      if (!state.client.hasSpouse) return true;
      return isObjectValid(validation.spouse);
    };

    const isAccountsValid = () => {
      for (let idxAccount = 0; idxAccount < validation.accounts.length; idxAccount++) {
        if (!isObjectValid(validation.accounts[idxAccount])) return false;
      }
      return true;
    };

    const isGoalsValid = () => {
      for (let idxGoal = 0; idxGoal < validation.goals.length; idxGoal++) {
        if (!isObjectValid(validation.goals[idxGoal])) return false;
      }
      return true;
    };

    const isIncomesValid = () => {
      for (let idxIncome = 0; idxIncome < validation.incomes.length; idxIncome++) {
        if (!isObjectValid(validation.incomes[idxIncome])) return false;
      }

      return true;
    };

    return (isClientValid() &&
      isSpouseValid() &&
      isAccountsValid() &&
      isGoalsValid() &&
      isIncomesValid());

  };

  const validateFuturePlan = () => {

    const validateFiaTransfers = () => {
      for (let k = 0; k < futurePlanValidation.fiaTransfers.length; k++) {
        if (!isObjectValid(futurePlanValidation.fiaTransfers[k])) return false;
      }
      return true;
    }

    const validateInsuranceTransfers = () => {
      for (let k = 0; k < futurePlanValidation.insuranceTransfers.length; k++) {
        if (!isObjectValid(futurePlanValidation.insuranceTransfers[k])) return false;
      }

      return true;
    };

    const validateRothTransfers = () => {
      for (let k = 0; k < futurePlanValidation.rothTransfers.length; k++) {
        if (!isObjectValid(futurePlanValidation.rothTransfers[k])) return false;
      }
      return true;
    };

    const validateSpendingGoals = () => {
      for (let k = 0; k < futurePlanValidation.spendingGoals.length; k++) {
        if (!isObjectValid(futurePlanValidation.spendingGoals[k])) return false;
      }
      return true;
    };

    const validateUpsideValue = (item) => {
      if (item.upsideType === "PAR") {
        return item.upsideRate >= 0 && item.upsideRate <= 200;
      }

      return item.upsideRate >= 0 && item.upsideRate <= 20;
    }

    const validateDownsideValue = (item) => {
      if (!item.rila) return true;
      if (item.downsideType === "PAR") {
        return item.downsideRate >= 0 && item.downsideRate <= 100;
      } else if (item.downsideType === "BUFFER") {
        return item.downsideRate >= 0 && item.downsideRate <= 30;
      }
      return item.downsideRate >= -30 && item.downsideRate <= 0;
    }

    const createUpsideValidationMessage = (item) => {

      const UPSIDE_VALIDATIONS = {
        RILA: {
          CAP: "RILA Upside Cap values should be between 0% and 20%",
          PAR: "RILA Upside Par values should be between 0% and 200%"
        },
        FIA: {
          CAP: "FIA Cap values should be between 0% and 20%",
          PAR: "FIA Par values should be between 0% and 200%"
        }
      }

      if (item.rila) {
        return UPSIDE_VALIDATIONS["RILA"][item.upsideType];
      }

      return UPSIDE_VALIDATIONS["FIA"][item.upsideType];
    };

    const createDownsideValidationMessage = (item) => {
      const DOWNSIDE_VALIDATIONS = {
        PAR: "RILA Downside Par values should be between 0% and 100%",
        FLOOR: "RILA Downside Floor values should be between -30% and 0%",
        BUFFER: "RILA Downside Buffer values should be between 0% and 30%",
      }

      return DOWNSIDE_VALIDATIONS[item.downsideType];
    };

    const rothConversionValidatePayoutFactors = (item) => {
      if (item.destination !== ROTH_DESTINATION_INCREASING_PAYOUT_FIA && item.destination !== ROTH_DESTINATION_LEVEL_INCOME_FIA) return true;

      if (item.destination === ROTH_DESTINATION_INCREASING_PAYOUT_FIA) {
        return item.payoutFactors >= 0 && item.payoutFactors <= 20;
      }

      return item.payoutFactors >= 0 && item.payoutFactors <= 15;
    };

    const validatePayoutCola = (item) => {
      if (item.annuityType !== "GUARANTEED_INCOME") return true;
      return item.payoutCola >= 0 && item.payoutCola <= 5;
    };

    const rothConversionValidateBaseRollUpRate = (item) => {
      if (item.destination !== ROTH_DESTINATION_INCREASING_PAYOUT_FIA) return true;
      return item.baseRollUpRate >= 0 && item.baseRollUpRate <= 20;
    }

    const rothConversionValidateBenefitBaseBonus = (item) => {
      if (item.destination !== ROTH_DESTINATION_INCREASING_PAYOUT_FIA) return true;
      return item.benefitBaseBonus >= 0 && item.benefitBaseBonus <= 20;
    }

    const rothConversionValidateGrowthMultiplier = (item) => {
      if (item.destination !== ROTH_DESTINATION_INCREASING_PAYOUT_FIA) return true;
      return item.growthMultiplier >= 0 && item.growthMultiplier <= 15;
    };

    const rothConversionValidateStackingMultiplier = (item) => {
      if (item.destination !== ROTH_DESTINATION_INCREASING_PAYOUT_FIA) return true;
      return item.stackingMultiplier >= 0 && item.stackingMultiplier <= 500;
    };

    setFuturePlanValidation({
      fiaTransfers: state.fiaTransfers.map((item) => {
        return {
          accountId: {
            valid: item.accountId !== null,
            message: "Please choose a funding source",
            show: false
          },
          transferAmount:
          {
            valid: item.transferAmount >= 0.1 && item.transferAmount <= MAX_CURRENCY_FUTURE_ADJUSMENTS,
            message: "Please review transfer amount to ensure it is valid.",
            show: false
          },
          transferEndYear:
          {
            valid: item.transferEndYear >= currentYear &&
              item.transferEndYear <= MAX_YEAR,
            message: "Please review transfer end year to ensure it is valid.",
            show: false
          },
          transferStartYear: {
            valid: item.transferStartYear >= currentYear && item.transferStartYear <= item.transferEndYear,
            message: "Please review transfer start year to ensure it is valid.",
            show: false
          },
          accountToTransfer: {
            valid: item.accountId != null,
            message: "Please review account transfer to ensure it is valid.",
            show: false
          },
          yearsOfDeferral: item.annuityType === "GUARANTEED_INCOME" ?
            {
              valid: item.yearsOfDeferral + state.client?.age >= 50,
              message: `FIA Payouts can only begin at age 50. The client is ${state.client.age} years old and the current FIA payout is set to ${item.yearsOfDeferral} years of deferral.  Please adjust the client age and recalculate to view the Future Adjustments.`,
              show: true,
            }
            :
            {
              valid: true,
              message: "",
              show: false,
            },
            upsideRate: validateUpsideValue(item) ? {
              valid: true,
              message: "",
              show: false,
            } : {
              valid: false,
              message: createUpsideValidationMessage(item),
              show: true
            },
          downsideRate: validateDownsideValue(item) ?  {
            valid: true,
            message: "",
            show: false,
          } : {
            valid: false,
            message: createDownsideValidationMessage(item),
            show: true
          },
          payoutCola: {
            valid: validatePayoutCola(item),
            message: "Please review payout COLA to ensure they are valid.",
            show: true
          },
        };
      }),
      insuranceTransfers: state.insuranceTransfers.map((item) => {
        if (item.insuranceType === "GUARANTEED_INCOME") {
          return {
            insuranceDetails: {
              valid: item.insuranceDetailsValid,
              message: "Missing File or Bad File",
              show: false
            },
            accountToTransfer: {
              valid: item.accountId != null,
              message: "Please review account transfer to ensure it is valid.",
              show: false
            },
          }
        }

        return {
          transferAmount:
          {
            valid: item.transferAmount >= 0.1 && item.transferAmount <= MAX_CURRENCY_FUTURE_ADJUSMENTS,
            message: "Please review insurance transfers to ensure it is valid.",
            show: false
          },
          transferEndYear:
          {
            valid: item.transferEndYear >= currentYear &&
              item.transferEndYear <= MAX_YEAR,
            message: "Please review transfer end year to ensure it is valid.",
            show: false
          },
          accountToTransfer: {
            valid: item.accountId != null,
            message: "Please review account transfer to ensure it is valid.",
            show: false
          },
          deathBenefit: {
            valid: item.deathBenefit >= 0.1 && item.transferAmount <= MAX_CURRENCY_FUTURE_ADJUSMENTS,
            message: "Please review death benefit to ensure it is valid.",
            show: false
          },
          insuranceDetails: {
            valid: true,
            message: '',
            show: false
          }
        }

      }),
      rothTransfers: state.rothTransfers.map((item) => {
        return {
          transferAmount:
          {
            valid: (item.transferAmount >= 0.1 && item.transferAmount <= MAX_CURRENCY_FUTURE_ADJUSMENTS) || item.conversionType === "ALL",
            message: "Please review transfer amount to ensure it is valid.",
            show: false
          },
          detailsAccountMust_100: {
            valid: (parseFloat(item.bonds) + parseFloat(item.cash) + parseFloat(item.stocks)) === 100,
            message: "Please ensure the account allocation for roth transfer adds up to 100%",
            show: false
          },
          numberOfYears: {
            valid: item.noOfYears >= 1,
            message: "Please review number of years to ensure it is valid.",
            show: false
          },
          payoutFactors: {
            valid: rothConversionValidatePayoutFactors(item),
            message: "Please review payout factors to ensure they are valid.",
            show: false
          },
          baseRollUpRate: {
            valid: rothConversionValidateBaseRollUpRate(item),
            message: "Please review Base Roll Out Rates to ensure they are valid.",
            show: false
          },
          benefitBaseBonus: {
            valid: rothConversionValidateBenefitBaseBonus(item),
            message: "Please review Benefit Base Bonuses to ensure they are valid.",
            show: false
          },
          growthMultiplier: {
            valid: rothConversionValidateGrowthMultiplier(item),
            message: "Please review Growth Multipliers to ensure they are valid.",
            show: false
          },
          stackingMultiplier: {
            valid: rothConversionValidateStackingMultiplier(item),
            message: "Please review Stacking Multipliers to ensure they are valid.",
            show: false
          }

        };
      }),
      spendingGoals: state.spendingGoals.map((item) => {
        return {
          transferAmount: {
            valid: item.amount >= 0.1 && item.amount <= MAX_CURRENCY_FUTURE_ADJUSMENTS,
            message: "Amount for goals invalid",
            show: false
          }
        }
      })
    });

    return (
      validateRothTransfers() &&
      validateInsuranceTransfers() &&
      validateFiaTransfers() &&
      validateSpendingGoals()
    );
  };

  const updateSavedPlan = (responseActualPlan, responseFuturePlan, planStatus) => {
    const getItemFundingSourceId = (item, id) => {
      if (item.fundingSourceType === "ACCOUNT") return id;
      if (item.fundingSourceType === "EXCESS_INCOME") return FUNDING_SOURCE_EXCESS_INCOME;
      return FUNDING_SOURCE_CURRENT_INCOME;
    }

    const getOwnerTrustNameIfApplicable = (dataItem, field) => {
      if (dataItem[field] === "RELATION") return 'CO_CLIENT';
      if (dataItem[field] === "TRUST") return dataItem.trustName;
      return dataItem[field];
    };

    function generateTrustList(incomes, accounts) {
      let trustList = [];

      const addToTrustList = (item) => {
        if (item.appliesTo === 'TRUST' && !trustList.some(trust => trust.toLowerCase() === item.trustName.toLowerCase())) {
          trustList.push(item.trustName);
        }
      };

      incomes.forEach(addToTrustList);
      accounts.forEach(addToTrustList);

      return trustList;
    }

    const trustList = generateTrustList(responseActualPlan.data.incomes, responseActualPlan.data.accounts);

    dispatch({
      type: ACTION_SET_TRUST_LIST,
      value: trustList
    });

    dispatch({
      type: SAGA_GET_PLANINPUT,
      value: {
        accounts: responseActualPlan.data.accounts,
        goals: responseActualPlan.data.goals,
        incomes: responseActualPlan.data.incomes.map((item) => {
          return {
            ...item,
            showJointTrustOptions: item.incomeType === "OTHER"
          }
        }),
        assumptions: responseActualPlan.data.planAssumptions,
        fiaTransfers: responseFuturePlan.fiaTransfers.map(item => {
          return {
            ...item,
            averageReturn: sAndPHistoricalReturn.averageReturn / 100,
            standardDeviation: sAndPHistoricalReturn.standardDeviation / 100,
          }
        }),
        insuranceTransfers: responseFuturePlan.insuranceTransfers,
        rothTransfers: responseFuturePlan.rothTransfers,
        spendingGoals: responseFuturePlan.spendingGoals
      }
    })

    const retirementYear = responseActualPlan.data.client.retirementAge;
    setTimeout(() => {
      if (responseActualPlan.data.planStatus.includes(PLAN_STATUS.published)) {
        setCalculateBtnLabel("Recalculate");
      } else {
        setCalculateBtnLabel("Calculate");
      }
    }, 100);
    setState({
      ...state,
      isCalculated: responseActualPlan.data.planStatus.includes(PLAN_STATUS.published),
      showFutureAdjustments: (responseActualPlan.data.planStatus.includes(PLAN_STATUS.published) || !props.hideFutureAdjustments),
      planStatus: planStatus ? planStatus : responseActualPlan.data.planStatus,
      client: {
        id: responseActualPlan.data.client.id,
        age: responseActualPlan.data.client.age,
        firstName: responseActualPlan.data.client.firstName,
        isMarried: responseActualPlan.data.client.isMarried, // filing status?
        isRetired: responseActualPlan.data.client.isRetired,
        hasSpouse: responseActualPlan.data.spouse !== null,
        lastName: responseActualPlan.data.client.lastName,
        retirementAge: {
          year: retirementYear,
          value: retirementYear,
        },
        filingStatus: {
          id: responseActualPlan.data.client.isMarried ? FILINGSTATUS_MARRIED : FILINGSTATUS_SINGLE,
          value: responseActualPlan.data.client.isMarried ? "Married" : "Single",
        }
      },
      assumptions: {
        cola: responseActualPlan.data.planAssumptions.cola / 100,
        ssCola: responseActualPlan.data.planAssumptions.ssCola / 100,
        pensionCola: responseActualPlan.data.planAssumptions.pensionCola / 100,
        stateTax: responseActualPlan.data.planAssumptions.stateTax / 100,
        capitalGainsTax: responseActualPlan.data.planAssumptions.capitalGainsTax / 100,
        ficaTax: responseActualPlan.data.planAssumptions.ficaTax / 100
      },
      spouse: responseActualPlan.data.spouse != null
        ? {
          id: responseActualPlan.data.spouse.id,
          firstName: responseActualPlan.data.spouse.firstName,
          lastName: responseActualPlan.data.spouse.lastName,
          age: responseActualPlan.data.spouse.age,
          isRetired: responseActualPlan.data.spouse.isRetired,
          retirementAge: {
            name: responseActualPlan.data.spouse.retirementAge,
            value: responseActualPlan.data.spouse.retirementAge,
          },
          isMarried: responseActualPlan.data.spouse.isMarried,
        } : state.spouse,
      clientQuestionView: responseActualPlan.data.clientQuestionView.map((item, index) => {
        return {
          answer: item.answer,
          clientQuestionId: item.clientQuestionId,
          questionId: item.questionId,
          editIndex: index
        }
      }),
      accounts: responseActualPlan.data.accounts.map((item, index) => {
        return {
          accountType: item.accountType,
          accountTypeOtherName: item.accountTypeOtherName,
          bonds: item.bonds,
          cash: item.cash,
          contributions: {
            amount: item.contributions?.amount,
            endYear: item.contributions?.endYear,
            frequency: item.contributions?.frequency,
            id: item.contributions?.id,
            startYear: item.contributions?.startYear,
            contributionSourceType: item.contributions?.contributionSourceType,
            editIndex: index,
            inEdit: true,
            invalidFields: [],
          },
          costBasis: item.costBasis,
          id: item.id,
          name: item.name,
          stocks: item.stocks,
          taxType: item.taxType.replace("_", "-"),
          value: item.value,
          owner: getOwnerTrustNameIfApplicable(item, "appliesTo"),
          trustName: item.trustName,
          editIndex: index,
          isExpanded: false,
          inEdit: true,
          invalidFields: [],
        };
      }),
      goals: responseActualPlan.data.goals.map((item, index) => {
        return {
          id: item.id,
          editIndex: index,
          inEdit: true,
          amount: item.amount,
          endYear: item.endYear,
          incomeType: item.incomeType,
          frequency: item.frequency,
          startYear: item.startYear,
        };
      }),
      incomes: responseActualPlan.data.incomes.map((item, index) => {
        return {
          id: item.id,
          editIndex: index,
          inEdit: true,
          amount: item.amount,
          endYear: item.endYear,
          incomeType: item.incomeType,
          incomeTypeOtherName: item.incomeTypeOtherName,
          frequency: item.frequency,
          startYear: item.startYear,
          owner: getOwnerTrustNameIfApplicable(item, "appliesTo"),
          trustName: item.trustName,
          taxed: item.tax,
          prevIncomeType: { taxType: item.incomeType, rate: item.tax } // Used for put value in 85tax rate for social security
        };
      }),
      insurancePolicies: responseActualPlan.data.insurancePolicies.map((item, index) => {
        return {
          ...item,
          inEdit: true,
          editIndex: index
        }
      }),
      fiaTransfers: responseFuturePlan.fiaTransfers.map((item, index) => {
        return {
          ...item,
          accountId: getItemFundingSourceId(item, item.accountId),
          accountType: item.accountType,
          annuityType: item.annuityType,
          baseRollUpRate: item.baseRollUpRate,
          benefitBaseBonus: item.benefitBaseBonus,
          hypotheticalIndexReturn: item.hypotheticalIndexReturn,
          payoutFactors: item.payoutFactors,
          payoutCola: item.payoutCola,
          payOutType: item.payOutType ? item.payOutType : "LEVEL",
          premiumBonus: item.premiumBonus,
          taxType: item.taxType.replace("_", "-"),
          transferAmount: item.transferAmount,
          transferEndYear: item.transferEndYear,
          transferStartYear: item.transferStartYear,
          transferId: item.transferId,
          yearsOfDeferral: item.yearsOfDeferral,
          rila: item.rila,
          upsideType: item.upsideType,
          upsideRate: item.upsideRate,
          downsideType: item.downsideType,
          downsideRate: item.downsideRate,
          averageReturn: sAndPHistoricalReturn.averageReturn / 100,
          standardDeviation: sAndPHistoricalReturn.standardDeviation / 100,
          owner: getOwnerTrustNameIfApplicable(item, "appliesTo"),
          trustName: item.trustName,
          stackingMultiplier: item.stackingMultiplier,
          increasingGrowthMultiplier: item.increasingGrowthMultiplier,
          editIndex: index,
        }
      }),
      insuranceTransfers: responseFuturePlan.insuranceTransfers.map((item, index) => {
        return {
          ...item,
          accountId: getItemFundingSourceId(item, item.accountId),
          accountType: item.accountType,
          cashValueReturn: item.cashValueReturn,
          deathBenefit: item.deathBenefit,
          deathBenefitReturn: item.deathBenefitReturn,
          insuranceDetails: item.insuranceDetails,
          insuranceDetailsValid: true,
          insuranceType: item.insuranceType,
          taxType: item.taxType,
          transferAmount: item.transferAmount,
          transferEndYear: item.transferEndYear,
          transferId: item.transferId,
          owner: getOwnerTrustNameIfApplicable(item, "appliesTo"),
          editIndex: index,
          trustName: item.trustName
        }
      }),
      rothTransfers: responseFuturePlan.rothTransfers.map((item, index) => {
        return {
          accountId: item.accountId,
          bonds: item.bonds,
          cash: item.cash,
          conversionType: item.conversionType,
          stocks: item.stocks,
          noOfYears: item.noOfYears,
          transferAmount: item.conversionType === "ALL" ? 0 : item.transferAmount,
          transferId: item.transferId,
          owner: getOwnerTrustNameIfApplicable(item, "appliesTo"),
          transferStartYear: item.transferStartYear,
          editIndex: index,
          trustName: item.trustName
        }
      }),
      spendingGoals: responseFuturePlan.spendingGoals.map((item, index) => {
        return {
          id: item.id,
          editIndex: index,
          inEdit: true,
          amount: item.amount,
          endYear: item.endYear,
          frequency: item.frequency,
          startYear: item.startYear
        }
      })

    });

  };

  const needSaveAdjustmentAdvanced = (planInput) => {
    if (state.needSaveAdjustmentFirst) return true;

    const adjustmentPayload = getPayloadFuturePlan(planInput);
    let needSaveFirst = false;

    if (!needSaveFirst) {
      adjustmentPayload.fiaTransfers.forEach(item => {
        if (planInput.accounts.filter(a => a.id === item.accountId).length === 0) needSaveFirst = true;
      });
    }
    if (!needSaveFirst) {
      adjustmentPayload.insuranceTransfers.forEach(item => {
        if (planInput.accounts.filter(a => a.id === item.accountId).length === 0) needSaveFirst = true;
      });
    }
    if (!needSaveFirst) {
      adjustmentPayload.rothTransfers.forEach(item => {
        if (planInput.accounts.filter(a => a.id === item.accountId).length === 0) needSaveFirst = true;
      });
    }

    if (!needSaveFirst) {
      state.deletedAccountTransfer.forEach(delAT => {
        state.deletedAccounts.forEach(delA => {
          if (!needSaveFirst && delAT === delA) needSaveFirst = true;
        });
      });
    }
    return needSaveFirst;
  };

  const getCorrectAccountId = (element, planInput, types) => {

    let accountId = null;
    const selectedAccount = planInput.accounts.filter(item => item.id === element.accountId);
    if (selectedAccount.length > 0) {
      accountId = selectedAccount[0].id;
    } else {
      planInput.accounts
          .sort((a, b) => b.value - a.value)
          .forEach(item => {
            if (accountId == null && types != null && types.length > 0 && types.includes(item.taxType)) {
              accountId = item.id;
            } else if (accountId == null && (types == null || types.length === 0)) {
              accountId = item.id;
            }
          });
    }

    if (accountId === null) accountId = planInput.accounts[0].id;

    return accountId;
  };

  const determineOwner = (dataItem, field) => {
    const STANDARD_OPTIONS = ["CLIENT", "CO_CLIENT", "SPOUSE",  "JOINT"];

    if (STANDARD_OPTIONS.includes(dataItem[field])) return dataItem[field];
    return "TRUST";
  }

  const mapFIAOrInsuranceItemForSave = (payload) => (item) => {

    if (item.accountId < 0) {
      return {
        ...item,
        accountId: null,
        transferId: null,
        fundingSourceType: item.accountId === FUNDING_SOURCE_EXCESS_INCOME ? "EXCESS_INCOME" : "CURRENT_INCOME",
        conversionType: item.isAccountRothConversionIntoFIA ? item.conversionType : null,
      }
    }

    return {
      ...item,
      accountId: getCorrectAccountId(item, payload),
      fundingSourceType: "ACCOUNT"
    }
  };

  const createFuturePlan = async (wizardState) => {

    const getPlanOptimizationType = () => {
      if (wizardState.balanced) return "BALANCED";
      if (wizardState.accumulation) return "ACCUMULATION";
      return "STABILITY";
    }

    const payload = {
      id: wizardState.id,
      planOptimizationType: getPlanOptimizationType(),
      annuityAllocation: wizardState.annuitiesAllocation,
      balanced: wizardState.balancedAllocation
    };

    await saveFuturePlanWizardSettings(state.client.id, payload, token);
    await updatePlan();
  };

  const savePlan = async (showMessageSuccefull) => {

    if (!validateAdvisorId()) return;

    if (!validation.client.firstName.valid || !validation.client.lastName.valid) {
      // setState((v) => ({ ...v, openModalPlanValidation: true }))
      return false;
    }

    const retirementYear = state.client.retirementAge.year;
    const married = state.client.filingStatus.id == FILINGSTATUS_MARRIED;

    const payload = {
      advisorId: parseInt(fpid),
      planStatus: PLAN_STATUS.saved,
      client: {
        id: state.client.id,
        firstName: state.client.firstName,
        lastName: state.client.lastName,
        age: state.client.age,
        isRetired: state.client.isRetired,
        retirementAge: retirementYear,
        isMarried: married
      },
      spouse: state.client.hasSpouse
        ? {
          id: state.spouse.id,
          firstName: state.spouse.firstName,
          lastName: state.spouse.lastName,
          age: state.spouse.age,
          isRetired: state.spouse.isRetired,
          retirementAge: state.spouse.retirementAge.value == "Retired" ? state.spouse.age : state.spouse.retirementAge.value,
        }
        : null,
      dependents: [],
      incomes: state.incomes.map((item) => {
        return {
          id: item.id,
          amount: item.amount,
          frequency: item.frequency,
          startYear: item.startYear,
          endYear: item.endYear,
          incomeType: item.incomeType,
          incomeTypeOtherName: item.incomeTypeOtherName,
          appliesTo: determineOwner(item, "owner"),
          tax: item.taxed,
          trustName: item.owner
        };
      }),
      accounts: state.accounts.map((item) => {
        return {
          id: item.id,
          name: item.name,
          taxType: item.taxType.replace("-", "_"),
          accountType: item.accountType,
          accountTypeOtherName: item.accountTypeOtherName,
          value: item.value,
          costBasis: item.costBasis,
          contributions: {
            id: item.contributions.id,
            amount: item.contributions.amount ? item.contributions.amount : 0,
            frequency: item.contributions.frequency ? item.contributions.frequency : "YEARLY",
            startYear: item.contributions.startYear ? item.contributions.startYear : getCurrentYear(),
            endYear: item.contributions.endYear ? item.contributions.endYear : getCurrentYear(),
            contributionSourceType: item.contributions.contributionSourceType ? item.contributions.contributionSourceType : 'OUTSIDE_SOURCE',
          },
          trustName: item.owner,
          stocks: item.stocks,
          bonds: item.bonds,
          cash: item.cash,
          appliesTo: determineOwner(item, "owner")
        };
      }),
      goals: state.goals.map((item) => {
        return {
          id: item.id,
          amount: item.amount,
          frequency: item.frequency,
          startYear: item.startYear,
          endYear: item.endYear,
        };
      }),
      planAssumptions: {
        cola: (state.assumptions.cola * 100).toFixed(2),
        pensionCola: (state.assumptions.pensionCola * 100).toFixed(2),
        ssCola: (state.assumptions.ssCola * 100).toFixed(2),
        stateTax: (state.assumptions.stateTax * 100).toFixed(2),
        capitalGainsTax: (state.assumptions.capitalGainsTax * 100).toFixed(2),
        ficaTax: (state.assumptions.ficaTax * 100).toFixed(2),
      },
      clientQuestionView: [...state.clientQuestionView],
      insurancePolicies: state.insurancePolicies
    };

    let response;
    if (needSaveAdjustmentAdvanced(payload)) {
      let adjustmentPayload = getPayloadFuturePlan(payload);

      adjustmentPayload.fiaTransfers = adjustmentPayload.fiaTransfers.map(item => {
        return mapFIAOrInsuranceItemForSave(payload)(item);
      });
      adjustmentPayload.insuranceTransfers = adjustmentPayload.insuranceTransfers.map(item => {
        return mapFIAOrInsuranceItemForSave(payload)(item);
      });
      adjustmentPayload.rothTransfers = adjustmentPayload.rothTransfers.map(item => {
        item.accountId = getCorrectAccountId(item, payload, ["PRE_TAX"]);
        return item;
      }).filter(item => item.accountId != null);

      await saveAdjustments(state.client.id, adjustmentPayload, authToken);

      response = await savePlanInputs(fpid, payload, authToken);
      setState({
        ...state,
        planStatus: PLAN_STATUS.saved,
        client: {
          ...state.client,
          id: response.data.client.id
        },
        deletedAccounts: [],
        deletedAccountTransfer: [],
        needSaveAdjustmentFirst: false,
      });

      if (response.status === 200 && showMessageSuccefull !== false) {
        dispatch({
          type: ACTION_LOCK_FUTURE_DESTINATION,
          value: state.fiaTransfers.length === 0 && state.insuranceTransfers.length === 0 && state.rothTransfers.length === 0 && state.spendingGoals.length === 0
        });
        updatePlan(PLAN_STATUS.saved);
        openModal("Plan saved successfully");
      }
    } else {
      response = await savePlanInputs(fpid, payload, authToken);
      setState({
        ...state,
        planStatus: PLAN_STATUS.saved,
        client: {
          ...state.client,
          id: response.data.client.id
        },
        deletedAccounts: [],
        deletedAccountTransfer: [],
        needSaveAdjustmentFirst: false,
      });

      if (response.status === 200 && showMessageSuccefull !== false) {
        if (state.showFutureAdjustments && !props.hideFutureAdjustments && state.accounts.length > 0) {
          const adjustmentPayload = getPayloadFuturePlan(response.data);
          adjustmentPayload.fiaTransfers = adjustmentPayload.fiaTransfers.map(item => {
            return mapFIAOrInsuranceItemForSave(payload)(item);
          });
          adjustmentPayload.insuranceTransfers = adjustmentPayload.insuranceTransfers.map(item => {
            return mapFIAOrInsuranceItemForSave(payload)(item);
          });
          await saveAdjustments(state.client.id, adjustmentPayload, authToken);
        }

        dispatch({
          type: ACTION_LOCK_FUTURE_DESTINATION,
          value: state.fiaTransfers.length === 0 && state.insuranceTransfers.length === 0 && state.rothTransfers.length === 0 && state.spendingGoals.length === 0
        });
        updatePlan(PLAN_STATUS.saved);
        openModal("Plan saved successfully");
      }
    }
    callbackIsPageUpdated(false);

    await updateSavedPlan(
        response,
        {
          fiaTransfers: state.fiaTransfers.map(item => {
            return {
              ...item,
              appliesTo: item.owner,
            }
          }),
          insuranceTransfers: state.insuranceTransfers.map(item => {
            return {
              ...item,
              appliesTo: item.owner,
            }
          }),
          rothTransfers: state.rothTransfers.map(item => {
            return {
              ...item,
              appliesTo: item.owner,
            }
          }),
          spendingGoals: state.spendingGoals.map(item => {
            return {
              ...item,
              appliesTo: item.owner,
            }
          })
        },
        PLAN_STATUS.saved
    );

    return response.data.client.id;
  };

  const publish = async () => {
    if (state.goals.length === 0) {
      return openModal('At least one goal must be saved before calculating the plan.')
    }

    if (!validate()) {

      setState((v) => ({ ...v, openModalPlanValidation: true }))
      throw 'validation fails'
    }

    console.log("publish");
    const clientId = await savePlan(false);

    await publishPlan(clientId, authToken);

    setState((v) => ({
      ...v,
      isCalculated: false,
      showFutureAdjustments: true
    }));
  };

  const getPayloadFuturePlan = (data) => {
    return {
      fiaTransfers: [...state.fiaTransfers].map((item) => {
        return {
          ...item,
          transferAmount: item.transferAmount,
          taxType: item.taxType.replace("-", "_"),
          transferEndYear: item.transferEndYear,
          appliesTo: determineOwner(item, "owner"),
          trustName: item.owner,
          accountId: getDefaultAccountId(data.accounts, "appliesTo", item.accountId, item.owner),
        };
      }).filter((item) => item.accountId != null),
      insuranceTransfers: [...state.insuranceTransfers].map((item) => {
        return {
          ...item,
          transferAmount: item.insuranceType === "GUARANTEED_INCOME" ? 0 : item.transferAmount,
          taxType: "TAX_FREE",
          accountType: "ROTH_IRA",
          deathBenefit: item.deathBenefit,
          insuranceDetails: item.insuranceType === "GUARANTEED_INCOME" ?
            item.insuranceDetails : [],
          appliesTo: determineOwner(item, "owner"),
          trustName: item.owner,
          accountId: getDefaultAccountId(data.accounts, "appliesTo", item.accountId, item.owner),
        };
      }).filter((item) => item.accountId != null),
      rothTransfers: [...state.rothTransfers].map((item) => {
        return {
          ...item,
          appliesTo: determineOwner(item, "owner"),
          trustName: item.owner,
          accountId: getDefaultAccountId(data.accounts, "appliesTo", item.accountId, item.owner,["PRE_TAX"]),
        }
      }).filter((item) => item.accountId != null),
      spendingGoals: [...state.spendingGoals].map((item) => {
        return {
          ...item,
          appliesTo: item.owner,
        }
      })
    };
  }

  const getDefaultAccountId = (accounts, ownerKey, currentAccountId, owner, types) => {
    if (currentAccountId < 0) return currentAccountId;

    let accountId;

    const isOwner = (item, ownerKey, owner) => {
      const STANDARD_OPTIONS = ["CLIENT", "SPOUSE", "CO_CLIENT", "JOINT"];

      if (STANDARD_OPTIONS.includes(item[ownerKey])) return item[ownerKey] === owner;

      return item.trustName.toUpperCase() === owner.toUpperCase();
    }

    if (currentAccountId != null) {
      accounts.forEach(item => {
        if (item.id === currentAccountId && isOwner(item, ownerKey, owner)) {
          accountId = item.id;
        }
      });
    }

    if (accountId == null) {
      accounts.sort((a, b) => b.value - a.value)
          .filter(item => isOwner(item, ownerKey, owner))
          .forEach(item => {
            if (accountId == null && types != null && types.length > 0 && types.includes(item.taxType)) {
              accountId = item.id;
            } else if (accountId == null && (types == null || types.length == 0)) {
              accountId = item.id;
            }
          });
    }
    return accountId;
  }

  const calculatePlan = async (message) => {
    if (!validateFuturePlan()) {
      console.log("FUTURE_PLAN FAILS");
      setState((v) => {
        return {
          ...v,
          openModalFutureValidation: true
        }
      });
      return;
    }

    setIsCalculating(true);

    publish().then(() => {

      dispatch({
        type: SAGA_GET_PLAN_CASH_FLOW,
        value: state.client.id,
        token: cookies["loginToken"],
      });

      saveFuturePlanRoadmap(state.client.id, authToken).then((response) => {
        if (response.status === 200) {
          updatePlan();
          openModal(message)
          props.setIsCalculated((v) => ({ isCalculated: !v.isCalculated }));
          setState((v) => ({
            ...v,
            planStatus: PLAN_STATUS.published,
          }));
          setIsCalculating(false);
          setTimeout(() => {
            setCalculateBtnLabel("Recalculate");
          }, 300);
        }
      });
    });
  }

  const findAnswers = (questions) => {
    return questions.map((item) => {
      const result = state.clientQuestionView.find((value) => value.questionId === item.id)
      const answer = result != undefined ? result.answer : "-";
      return {
        questionId: item.id,
        question: item.question,
        answer
      }
    })
  }

  const exportPdf = async () => {
    const assets = findAnswers(questionsPlan.assets);
    const lifeInsurance = findAnswers(questionsPlan.lifeinsurance);
    const disabilityinsuranceinputs = findAnswers(questionsPlan['ltc/disabilityinsuranceinputs'])
    const personalinformation = findAnswers(questionsPlan.personalinformation);
    const goals = findAnswers(questionsPlan.goals);

    const htmlString = ReactDOMServer.renderToStaticMarkup(
      <PdfPlanInput
        data={state}
        personalinformationQuestions={personalinformation}
        assetsQuestions={assets}
        lifeInsuranceQuestions={lifeInsurance}
        disabilityInsuranceQuestions={disabilityinsuranceinputs}
        goalsQuestions={goals}
      />
    );

    generatePDF(htmlString.replace(/"/g, "'"), state.client.id, authToken).then((response) => {
      if (response.status === 200) {
        window.open(`${SERVER_URL}/api/ifw/client/export-pdf?fileName=${response.data}`, '_blank');
      }
    })
  }

  const allowNavigation = (target) => {
    if (state.planStatus.includes(PLAN_STATUS.changed)) {
      updateUnsavedNavTarget(target);
      updateShowUnsavedChangesModal(true);
      return false;
    }

    // window.removeEventListener("beforeunload", unloadPageHandler, {capture: true});
    return true;
  }

  const viewDeck = () => {
    dispatch({
      type: ACTION_LOCK_FUTURE_DESTINATION,
      value: state.fiaTransfers.length === 0 && state.insuranceTransfers.length === 0 && state.rothTransfers.length === 0 && state.spendingGoals.length === 0
    });

    const target = `/presentation/${state.client.id}`;
    if (allowNavigation(target)) {
      window.location.href = target;
    }

  };

  const goPlanOutput = () => {

    const target = `/plan-output`;

    if (allowNavigation(target)) {
      dispatch({
        type: ACTION_LOCK_FUTURE_DESTINATION,
        value: state.fiaTransfers.length === 0 && state.insuranceTransfers.length === 0 && state.rothTransfers.length === 0 && state.spendingGoals.length === 0
      });

      getClient(state.client.id, authToken).then((value) => {
        dispatch({
          type: ACTION_SET_CURRENTCLIENT,
          value: value.data
        });
        window.location.href = target;
      })
    }
  };

  const goToClientList = () => {
    const target = `/ifw-users/2/${fpid}`;

    if (allowNavigation(target)) {
      window.location.href = target;
    }
  };

  const handleOpenPlanAutomationModal = () => {
    updateShowPlanAutomationModal(true);
  };

  const generateCalculateLabel = () => {
    if (!(authorization !== USER_CONCIERGE && (state.isCalculated || state.planStatus.includes(PLAN_STATUS.published)))) {
      if (state.planStatus.includes(PLAN_STATUS.incomplete) && props.isOutput) {
        setCalculateBtnLabel(" ");
      } else {
        setCalculateBtnLabel((isCalculating && calculateBtnLabel) ? calculateBtnLabel : "Calculate");
      }
    } else {
      setCalculateBtnLabel((isCalculating && calculateBtnLabel) ? calculateBtnLabel : "Recalculate");
    }
  };

  return (
    <Grid id={"pdf-output"} className={"plan-inputs-page"} container spacing={3}>
      {!props.hideControls && (
        <Grid container justifyContent={'space-between'} >
          <Grid className={"user-name"}>
            <Typography fontSize={25} component={'h2'} > {`FINANCIAL PROFESSIONAL: ${currentUserName.toString().toUpperCase()}`} </Typography>
          </Grid>
          <Grid>
            <Button onClick={goToClientList} height={"100%"}> Client list </Button>
          </Grid>
        </Grid>
      )}
      <Grid item xs={12}>
        <PersonalInformation
          fpid={fpid}
          validations={validation}
          client={state.client}
          spouse={state.spouse}
          updateClient={update("client")}
          updateSpouse={update("spouse")}
          exportPdf={exportPdf}
          answers={state.clientQuestionView}
          questions={questionsPlan.personalinformation}
          updateAdditional={updateQuestions("clientQuestionView")}
          goToClientList={goToClientList}
          readOnly={props.currentPlanReadyOnly}
        />
      </Grid>

      <Grid item xs={12}>
        <SavingsAndContributions
          validations={validation}
          accounts={state.accounts}
          incomes={state.incomes}
          update={handleIsAccountsModified}
          updateAccountContribution={updateAccountContribution}
          addAccount={addToCollection("accounts")}
          delete={deleteFromCollection("accounts")}
          questionsLtc={questionsPlan['ltc/disabilityinsuranceinputs']}
          questionsAssets={questionsPlan.assets}
          questionsLifeInsurance={questionsPlan.lifeinsurance}
          answers={state.clientQuestionView}
          updateAdditional={updateQuestions("clientQuestionView")}
          readOnly={props.currentPlanReadyOnly}
          client={state.client}
          spouse={state.spouse}
          policies={state.insurancePolicies}
          updatePolicies={(policies) => {
            setState({
              ...state,
              planStatus: PLAN_STATUS.changed,
              insurancePolicies: policies
            })
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Income
          validations={validation}
          incomes={state.incomes}
          update={updateCollection("incomes")}
          addIncome={addToCollection("incomes")}
          delete={deleteFromCollection("incomes")}
          client={state.client}
          spouse={state.spouse}
          readOnly={props.currentPlanReadyOnly}
        />
      </Grid>

      <Grid item xs={12}>
        <Goals
          validations={validation}
          goals={state.goals}
          update={updateCollection("goals")}
          addGoal={addToCollection("goals")}
          delete={deleteFromCollection("goals")}
          client={state.client}
          spouse={state.spouse}
          answers={state.clientQuestionView}
          questions={questionsPlan.goals}
          updateAdditional={updateQuestions("clientQuestionView")}
          readOnly={props.currentPlanReadyOnly}
        />
      </Grid>

      <Grid container ml={'1.50em'}>
        <Grid item xs={6}>

          <PlanAssumptions
            validations={validation}
            assumptions={state.assumptions}
            update={update("assumptions")}
            readOnly={props.currentPlanReadyOnly}
          />

        </Grid>

      </Grid>

      <Grid item xs={12}>
        <hr />
      </Grid>

      {
        state.showFutureAdjustments && !props.hideFutureAdjustments && state.accounts.length > 0 && (
          <Grid item xs={12}>
            <Accordion defaultExpanded  className="future-adjustments-accordion">
              <AccordionSummary
                  className="accordion-summary"
                  expandIcon={<ExpandMoreIcon />}
                  sx={{flexDirection: "row-reverse"}}
              >
                <Typography component={"h1"} variant={"h1"}>
                  Future Adjustments
                </Typography>
                <Button className={"plan-automation-button"} onClick={handleOpenPlanAutomationModal}>
                  Plan Automation
                </Button>
              </AccordionSummary>
              <AccordionDetails>
                <Grid item xs={12}>
                  <Fia
                      validations={futurePlanValidation}
                      fiaTransfers={state.fiaTransfers}
                      update={updateCollection("fiaTransfers")}
                      addTransfer={addToCollection("fiaTransfers")}
                      delete={deleteFromCollection("fiaTransfers")}
                      accounts={state.accounts}
                      client={state.client}
                      spouse={state.spouse}
                      sandpReturns={sAndPHistoricalReturn}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Insurance
                      validations={futurePlanValidation}
                      insuranceTransfers={state.insuranceTransfers}
                      update={updateCollection("insuranceTransfers")}
                      addTransfer={addToCollection("insuranceTransfers")}
                      delete={deleteFromCollection("insuranceTransfers")}
                      accounts={state.accounts}
                      client={state.client}
                      spouse={state.spouse}
                  />
                </Grid>
                <Grid item xs={12}>
                  <RothIra
                      validations={futurePlanValidation}
                      rothTransfers={state.rothTransfers}
                      update={updateCollection("rothTransfers")}
                      updateItemInCollection={updateItemInCollection("rothTransfers")}
                      addTransfer={addToCollection("rothTransfers")}
                      delete={deleteFromCollection("rothTransfers")}
                      accounts={state.accounts}
                      client={state.client}
                      spouse={state.spouse}
                      sandpReturns={sAndPHistoricalReturn}
                  />
                </Grid>
                <Grid item xs={12}>
                  <SpendingGoals
                      validations={futurePlanValidation}
                      spendingGoals={state.spendingGoals}
                      update={updateCollection("spendingGoals")}
                      addGoal={addToCollection("spendingGoals")}
                      delete={deleteFromCollection("spendingGoals")}
                  />
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        )
      }

      {(state.client.id !== null && showPlanAutomationModal) && <PlanAutomationWizard clientId={state.client.id} open={true} handleClose={() => updateShowPlanAutomationModal(false)} runWizard={createFuturePlan} />}

      {state.openModalPlanValidation && (
        <ValidationMessageModal
          validation={{ ...validation }}
          open={state.openModalPlanValidation}
          modal={'openModalPlanValidation'}
          setOpenModal={setState}
        />
      )}
      {state.openModalFutureValidation && (
        <ValidationMessageModal
          validation={{ ...futurePlanValidation }}
          open={state.openModalFutureValidation}
          modal={'openModalFutureValidation'}
          setOpenModal={setState}
        />
      )}
      <SuccessDialog handleOk={closeModal} message={message} open={isOpen} />

      <div style={{ marginBottom: '3em', padding: '1em' }}> </div>

      <ModalWarningAdvisor
        open={warningModal.isOpen}
        handleClose={warningModal.closeModal}
      />

      <UnsavedDataModal
        open={showUnsavedChangesModal}
        handleSave={() => {
          savePlan();
          updateShowUnsavedChangesModal(false);
        }}
        handleLeave={() => {
          // window.removeEventListener("beforeunload", unloadPageHandler, {capture: true});
          window.location.href = unsavedNavTarget;
        }}
      />

      <Grid item xs={12} className="plan-inputs-footer">
        <Grid container spacing={3}>
          {!props.isOutput && (
            <React.Fragment>
              <Grid item xs={3} className="button-div">
                <Button
                    style={{ width: '130px' }}
                    className={"button"}
                    onClick={() => viewDeck()}
                    disabled={!(authorization !== USER_CONCIERGE && (state.isCalculated || state.planStatus.includes(PLAN_STATUS.published)) && !props.hideFutureAdjustments)}
                >
                  View Deck
                </Button>
              </Grid>
              <Grid item xs={3} className="button-div">
                <Button
                    style={{ width: '130px' }}
                    className={"button"}
                    onClick={() => goPlanOutput()}
                    disabled={!(authorization !== USER_CONCIERGE && (state.isCalculated || state.planStatus.includes(PLAN_STATUS.published)) && !props.hideFutureAdjustments)}
                >
                  Plan Results
                </Button>
              </Grid>
            </React.Fragment>
          )}
          <Grid item xs={props.isOutput ? 6 : 3} className="button-div">
            {authorization !== USER_CONCIERGE && (
                <Button
                    style={{ width: '130px' }}
                    className={"button calculate"}
                    onClick={() => calculatePlan("Plan calculated successfully")}
                >
                  {calculateBtnLabel}
                </Button>
            )}
            {authorization === USER_CONCIERGE && (
                <Button
                    style={{ width: '180px' }}
                    className={"button"}
                    onClick={() => calculatePlan("Client has been submitted for review")}
                    disabled={!(authorization === USER_CONCIERGE && state.planStatus.includes(PLAN_STATUS.saved))}
                >
                  Submit for Review
                </Button>
            )}
          </Grid>
          <Grid item xs={props.isOutput ? 6 : 3} className="button-div">
            <Button
                style={{ width: '130px' }}
                className={"button"}
                onClick={() => savePlan()}
                disabled={!state.planStatus.includes(PLAN_STATUS.changed)}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Grid>

    </Grid>
  );
};

export default PlanInputs;
